module.exports = __webpack_public_path__ + "img/jose-hero-alt copy.c5d3bfd6.png";